import {
  createMatterIntakeTemplateQuestion,
  deleteMatterIntakeTemplateQuestion,
  retrieveMatterIntakeTemplateQuestions,
  updateMatterIntakeTemplateQuestion,
} from "@/lib/data/requests/matters/matter-intake-template-question";
import { queryKeys } from "@/lib/data/static";
import type { APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { toast } from "react-hot-toast";

export const retrieveMatterIntakeTemplateQuestionsOptions = (id?: string) => {
  return {
    queryKey: [queryKeys.matterSettings, "questions", id],
    queryFn: () => retrieveMatterIntakeTemplateQuestions(id),
    enabled: !!id,
  };
};

export const useCreateMatterIntakeTemplateQuestion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createMatterIntakeTemplateQuestion,
    onSuccess: () => {
      toast.success("Matter intake template question created");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(
        error,
        "Failed to create matter intake template question",
      );
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
  });
};

export const useUpdateMatterIntakeTemplateQuestion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      data: Parameters<typeof updateMatterIntakeTemplateQuestion>[0],
    ) => updateMatterIntakeTemplateQuestion(data),
    onSuccess: () => {
      toast.success("Matter intake template question updated");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(
        error,
        "Failed to update matter intake template question",
      );
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
  });
};

export const useDeleteMatterIntakeTemplateQuestion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      data: Parameters<typeof deleteMatterIntakeTemplateQuestion>[0],
    ) => deleteMatterIntakeTemplateQuestion(data),
    onSuccess: () => {
      toast.success("Matter intake template question deleted");
    },
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(
        error,
        "Failed to delete matter intake template question",
      );
    },
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: [queryKeys.matterSettings],
      });
    },
  });
};
